/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_CarrierInputs */

const en_samples_carrier = /** @type {(inputs: Samples_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier`)
};

const es_samples_carrier = /** @type {(inputs: Samples_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transportista`)
};

/**
* | output |
* | --- |
* | "Carrier" |
*
* @param {Samples_CarrierInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_carrier = /** @type {((inputs?: Samples_CarrierInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_CarrierInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_carrier(inputs)
	return es_samples_carrier(inputs)
});